import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-70e1bd9a"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/_createTextVNode("Exit")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ion_label = _resolveComponent("ion-label")!
  const _component_ion_chip = _resolveComponent("ion-chip")!
  const _component_ion_spinner = _resolveComponent("ion-spinner")!
  const _component_HeaderBar = _resolveComponent("HeaderBar")!

  return (_openBlock(), _createBlock(_component_HeaderBar, null, {
    left: _withCtx(() => [
      _createVNode(_component_ion_chip, {
        outline: "",
        color: "danger",
        onClick: _ctx.leaveAppointment
      }, {
        default: _withCtx(() => [
          _createVNode(_component_ion_label, null, {
            default: _withCtx(() => [
              _hoisted_1
            ]),
            _: 1
          })
        ]),
        _: 1
      }, 8, ["onClick"])
    ]),
    right: _withCtx(() => [
      _createElementVNode("span", {
        class: _normalizeClass(_ctx.statusChip.class)
      }, [
        _createVNode(_component_ion_chip, { class: "status-chip" }, {
          default: _withCtx(() => [
            _createVNode(_component_ion_label, null, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.statusChip.label), 1)
              ]),
              _: 1
            }),
            (_ctx.loading)
              ? (_openBlock(), _createBlock(_component_ion_spinner, {
                  key: 0,
                  name: "crescent"
                }))
              : _createCommentVNode("", true)
          ]),
          _: 1
        })
      ], 2)
    ]),
    _: 1
  }))
}